import { h } from "hyperapp";
import { actionsOnSelected } from "../../common/list-item-selector/actions-on-seleted";
import controlsCSS from "./controls.css";

export const NearPlaces = ({
  translations,
  actions: {
    fetchPortifolios,
    setPortifolio,
    setHasSelectedPlace,
    setSelectedPlace,
    setRadius,
    fetchUnvisitedPlaces,
  },
  section,
  state: {
    portifolios,
    portifolioID,
    clientID,
    disabled,
    loading,
    hasSelectedAPlace,
    selectedPlace,
    radius,
  },
}): JSX.Element => {
  return (
    <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0 pl-md-2 pl-lg-0">
      <div>
        <div class="">
          <label
            for="place"
            style="font-style: normal;
                color: #666666;
                font-weight: bold;
                margin-bottom:0;"
          >
            Apenas próximos do Local{" "}
          </label>

          <input
            readonly
            type="text"
            value={selectedPlace ? selectedPlace.name : ""}
            class="form-control"
            name=""
            id="place"
            placeholder={translations["selectAtTable"]}
            disabled={hasSelectedAPlace}
          />

          {hasSelectedAPlace && (
            <div
              id="cross"
              onclick={event => {
                setHasSelectedPlace(false);
                setSelectedPlace({ ...{} });
                fetchUnvisitedPlaces();

                setRadius({ radius: 1000 });
              }}
              class={controlsCSS["cross"]}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  d="M8.06405 6.00011L11.1596 2.90451C11.5395 2.52463 11.5395 1.90873 11.1596 1.52855L10.4717 0.840569C10.0918 0.460696 9.47589 0.460696 9.09571 0.840569L6.00011 3.93617L2.90451 0.840569C2.52464 0.460696 1.90873 0.460696 1.52855 0.840569L0.840569 1.52855C0.460696 1.90842 0.460696 2.52433 0.840569 2.90451L3.93617 6.00011L0.840569 9.09571C0.460696 9.47558 0.460696 10.0915 0.840569 10.4717L1.52855 11.1596C1.90842 11.5395 2.52464 11.5395 2.90451 11.1596L6.00011 8.06405L9.09571 11.1596C9.47558 11.5395 10.0918 11.5395 10.4717 11.1596L11.1596 10.4717C11.5395 10.0918 11.5395 9.47589 11.1596 9.09571L8.06405 6.00011Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
      <div class="mt-3">
        <label
          for="radius"
          style="font-style: normal;
        color: #666666;
        font-weight: bold;
        margin-bottom:0;"
        >
          Em um raio de{" "}
        </label>

        <select
          disabled={!hasSelectedAPlace}
          class="custom-select form-control"
          id="radius"
          onblur={event => setRadius({ radius: event.target.value })}
          value={hasSelectedAPlace ? radius : "default"}
        >
          {!hasSelectedAPlace && (
            <option selected value="default">
              {translations["selectANearPlace"]}
            </option>
          )}
          <option selected value="1000">
            1 km
          </option>
          <option value="5000">5 km</option>
          <option value="10000">10 km</option>
          <option value="50000">50 km</option>
          <option value="100000">100 km</option>
        </select>
      </div>
    </div>
  );
};
